import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegistrationVerifyListComponent } from './components/registration-verify-list/registration-verify-list.component';
import { RegistrationVerifyComponent } from './components/registration-verify/registration-verify.component';
import { RegistrationVerifyDetailsComponent } from './components/registration-verify-details/registration-verify-details.component';
import { RegistrationVerifySearchComponent } from './components/registration-verify-search/registration-verify-search.component';
import { ContactListComponent } from './components/contact-list/contact-listcomponent';

const routes: Routes = [
  { path: '', redirectTo: 'dang-ky-kiem-hoa', pathMatch: 'full' },
  { path: 'danh-sach-dang-ky-kiem-hoa', component: RegistrationVerifyListComponent },
  { path: 'danh-sach-cbcc', component: ContactListComponent },
  { path: 'dang-ky-kiem-hoa', component: RegistrationVerifyComponent },
  { path: 'tim-kiem', component: RegistrationVerifySearchComponent },
  { path: 'chi-tiet-dang-ky-kiem-hoa/:id', component: RegistrationVerifyDetailsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
